/**
 * Mirror of the backend's CanvasDesign (see photo-upload-backend
 * src/core/product-with-media/canvas/canvas-design.ts).
 *
 * This is a CONTRACT, not a convenience type: the backend runs
 * parseCanvasDesign over whatever is posted and rejects anything that does not
 * match, so a drift here is a 400 at add-to-cart rather than a type error here.
 */
export const CANVAS_DESIGN_SCHEMA = "canvas/1";

export type CanvasEdgeMode =
  "mirror" | "stretch" | "soft-stretch" | "color" | "wrap";
export type CanvasFilter = "none" | "bw" | "sepia";
export type CanvasOrientation = "portrait" | "landscape";

export interface CanvasCrop {
  /** All four in NORMALISED source coordinates (0..1), never pixels. */
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface CanvasDesign {
  schema: typeof CANVAS_DESIGN_SCHEMA;
  crop: CanvasCrop;
  rotation: 0 | 90 | 180 | 270;
  /** Omitted means "however the variant was defined". */
  orientation?: CanvasOrientation;
  edge: { mode: CanvasEdgeMode; color?: string };
  filter: CanvasFilter;
}

export const EDGE_MODES: CanvasEdgeMode[] = [
  "mirror",
  "stretch",
  "soft-stretch",
  "color",
  "wrap",
];

/** A whole-image crop, ready to be re-fitted to the chosen variant's aspect. */
export function makeDefaultDesign(): CanvasDesign {
  return {
    schema: CANVAS_DESIGN_SCHEMA,
    crop: { x: 0, y: 0, width: 1, height: 1 },
    rotation: 0,
    // The crop covers the whole print, sides included, and only its middle
    // goes on the face; the sides are that face's edge pulled outward and
    // softly blurred. Mirror put the whole crop on the face, which is not
    // what the editor or the print preview show.
    edge: { mode: "soft-stretch" },
    filter: "none",
  };
}
